import request from '../request'

//全国高校名单
export function collegeList(params) {
  return request({ url: '/api/Zonghe/collegeList',method: 'post',data: params})
}
//学校标识码
export function collegeBiaoshi(params) {
  return request({ url: '/api/Zonghe/collegeBiaoshi',method: 'post',data: params})
}
//军校查询
export function synthrsize_junxiao(params) {
  return request({ url: '/api/Zonghe/synthrsize_junxiao',method: 'post',data: params})
}
//世界前1000名大学
export function qian1000List(params) {
  return request({ url: '/api/Zonghe/qian1000List',method: 'post',data: params})
}
//学科评估
export function xuekeList(params) {
  return request({ url: '/api/Zonghe/xuekeList',method: 'post',data: params})
}
//查位次
export function chaSeat(params) {
  return request({ url: '/api/Zonghe/chaSeat',method: 'post',data: params})
}
//查询年份选择列表
export function selectYear(params) {
  return request({ url: '/api/Zonghe/selectYear',method: 'post',data: params})
}
//查批次
export function chaPice(params) {
  return request({ url: '/api/Zonghe/chaPice',method: 'post',data: params})
}
//往年征集
export function Collectionplan_index(params) {
  return request({ url: '/api/Collectionplan/index',method: 'post',data: params})
}
//填报与录取时间
export function tianbaoyu(params) {
  return request({ url: '/api/Zonghe/tianbaoyu',method: 'post',data: params})
}
//高考资讯列表
export function InfoMation_index(params) {
  return request({ url: '/api/InfoMation/index',method: 'post',data: params})
}
//高考资讯详情
export function InfoMation_detail(params) {
  return request({ url: '/api/InfoMation/detail',method: 'post',data: params})
}
//视频列表
export function VideoSeet_index(params) {
  return request({ url: '/api/VideoSeet/index',method: 'post',data: params})
}
//视频详情
export function VideoSeet_detail(params) {
  return request({ url: '/api/VideoSeet/detail',method: 'post',data: params})
}
//联系客服列表
export function ContantUser_index(params) {
  return request({ url: '/api/ContantUser/index',method: 'post',data: params})
}
//通过专业名称查询专业
export function major_name_search(params) {
  return request({ url: '/api/Zonghe/major_name_search',method: 'post',data: params})
}
//一分一档表
export function OneQuarter_index(params) {
  return request({ url: '/api/OneQuarter/index',method: 'post',data: params})
}
//根据专业查询开设院校
export function majorCollege(params) {
  return request({ url: '/api/Zonghe/majorCollege',method: 'post',data: params})
}
//根据院校查询所有专业
export function Mojor_recodeList(params) {
  return request({ url: '/api/Mojor/recodeList',method: 'post',data: params})
}
//查询字典-查询组别批次等
export function groupFind(params) {
  return request({ url: '/api/Admin.Config/groupFind',method: 'post',data: params})
}

export function batchGetgroup(params) {
  return request({ url: '/api/Admin.Config/batchGetgroup',method: 'post',data: params})
}



// WEBPACK FOOTER //
// ./src/api/gw/zonghe.js